<template>
  <div class='emoji-wrapper'>
    <div class='emoji-content'>

      <swiper class='emoji-content-swiper' :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(currentEmojiArr, currentKey) in currentAlbumKeys" :key="currentKey">
            <div class='emoji-content-item' v-for="(item, index) in currentEmojiArr" @click='emojiTap(item)' :key="index">
              <img :src="emojiList[currentAlbum][item].img" :class='{"emoji-content-img-emoji":currentAlbum == "emoji","emoji-content-img-other":currentAlbum != "emoji"}'></img>
            </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class='emoji-album'>
       <!-- <div class='emoji-album-left' wx:for="{{albumArr}}" wx:for-item="album" wx:key="{{album.album}}" data-album="{{album.album}}" bindtap='switchAlbum'>
        <image src='{{album.img}}' class='{{album.album == currentAlbum ? "emoji-album-left-img album-active" : "emoji-album-left-img"}}'></image>
      </div>  -->
      <div class='emoji-album-left' v-for="(album, index) in albumArr" @click='switchAlbum(album)'>
        <img :src='localAlbumImages[index]' class="emoji-album-left-img" :class='{"album-active":album.album == currentAlbum}'></img>
      </div>
      <!-- <div class='emoji-send' bindtap='emojiSend'>发送</div> -->
    </div>
  </div>
</template>

<script type="text/javascript">
  import EmojiObj from '@/utils/emojimap.js'
  import 'swiper/dist/css/swiper.css';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

  export default {
    name: "emoji",
    props: {

    },
    data () {
      return {
        swiperOption:{

        },
        localAlbumImages: [require('../../assets/images/album-emoji.png'), require('../../assets/images/album-ajtd.png'), require('../../assets/images/album-xxy.png'), require('../../assets/images/album-lt.png')],
        albumArr: [],
        currentAlbum: 'emoji',
        emojiList: {},
        currentAlbumKeys: [] //存储每一类别的key
      }
    },
    components:{
        swiper,
        swiperSlide,
    },
    created: function() {
      let currentAlbumKeys = this.splitAlbumKeys(Object.keys(EmojiObj.emojiList[this.currentAlbum]), this.currentAlbum == 'emoji' ? 23 : 10)
      this.albumArr = EmojiObj.albumArr;
      this.emojiList = EmojiObj.emojiList;
      this.currentAlbumKeys = currentAlbumKeys;
      console.log("emoji")
      console.log(EmojiObj.albumArr)
      console.log(EmojiObj.emojiList)
      console.log(currentAlbumKeys)
    },
    computed: {

    },
    methods:{
      /**
       * 切换emoji类别
       */
      switchAlbum: function(e) {
        let currentAlbum = e.album
        // 提前跟新一次，下面分类需要用到
        this.currentAlbum = currentAlbum;
        let currentAlbumKeys = this.splitAlbumKeys(Object.keys(this.emojiList[currentAlbum]), currentAlbum == 'emoji' ? 23 : 10, currentAlbum)

        this.currentAlbumKeys = currentAlbumKeys;
        console.log("emoji")
        console.log(currentAlbumKeys)
      },
      /**
       * 每页显示固定个数
       * arr数据源数组，space每个数组最大容量
       * [[], [], []]
       */
      splitAlbumKeys: function (arr, space, currentAlbum) {
        const delta = space || 23
        let result = [],
          factor = Math.ceil(arr.length / delta),
          begin = 0,
          end = 1
        if (factor == 1) {
          result = [[...arr]]
        } else {
          for (let i = 1; i < factor; i++) {
            let temp = []
            temp = [...arr.slice(begin, i * delta)]
            begin = i * delta
            result.push(temp)
          }
          result.push([...arr.slice(delta * (factor - 1), arr.length)])
        }
        if (currentAlbum == 'emoji' || this.currentAlbum == 'emoji') { // 只有emoji才添加删除按钮
          result.map((cata, index) => {
            if(index != (result.length-1)) {
              cata.push('[删除]')
            }
          })
          // console.log(result)
        }
        return result
      },
      /**
       * 单击emoji
       */
      emojiTap: function(emoji) {
        if (!emoji) return
        // console.log(emoji)
        this.$emit('emoji-click',emoji)
      },
      /**
       * 发送emoji
       */
      emojiSend: function () {
        this.$emit('emoji-send')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/emoji.vue